import {LogIn} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const LoginIcon = createLucideIcon(LogIn, 'LoginIcon');
